import React, { useState } from 'react';
import { i18n } from '../../i18n/i18n';
import { joinSeconds, splitSeconds } from '../../utils/stepTimer';

/**
 * "⏱ Timer" on a step in the editors (task editor and Master Admin standard tasks, 2026-10-19):
 * minutes and seconds; both empty / 0 = no timer.
 */
const StepTimerInput: React.FC<{ seconds?: number | null; onChange: (seconds: number | null) => void }> = ({ seconds, onChange }) => {
  const start = splitSeconds(seconds);
  const [min, setMin] = useState(seconds ? String(start.minutes) : '');
  const [sec, setSec] = useState(seconds ? String(start.seconds).padStart(2, '0') : '');

  const update = (m: string, s: string) => {
    setMin(m);
    setSec(s);
    onChange(joinSeconds(m, s));
  };
  const field = 'w-20 min-h-[44px] rounded-kid-tile border-2 border-kid-border-strong dark:border-kid-border-strong-dark bg-kid-card dark:bg-kid-card-dark text-kid-text dark:text-kid-text-dark px-2 text-base text-center tabular-nums focus:outline-none focus:border-kid-green';

  return (
    <div className="mb-3">
      <p className="block text-base font-bold mb-1">⏱ {i18n.t('admin_panel.step_timer_label')}</p>
      <div className="flex flex-wrap items-center gap-2">
        <label className="inline-flex items-center gap-1">
          <input type="number" inputMode="numeric" min={0} max={240} value={min} placeholder="0"
            onChange={(e) => update(e.target.value, sec)} className={field} aria-label={i18n.t('admin_panel.step_timer_minutes')} />
          <span className="text-sm">{i18n.t('admin_panel.step_timer_min')}</span>
        </label>
        <label className="inline-flex items-center gap-1">
          <input type="number" inputMode="numeric" min={0} max={59} value={sec} placeholder="00"
            onChange={(e) => update(min, e.target.value)} className={field} aria-label={i18n.t('admin_panel.step_timer_seconds')} />
          <span className="text-sm">{i18n.t('admin_panel.step_timer_sec')}</span>
        </label>
        {(min || sec) && (
          <button type="button" onClick={() => update('', '')} className="min-h-[44px] px-3 rounded-full border-2 border-kid-border-strong dark:border-kid-border-strong-dark text-sm font-bold">
            {i18n.t('admin_panel.step_timer_clear')}
          </button>
        )}
      </div>
      <p className="text-sm text-kid-text-muted dark:text-kid-text-muted-dark mt-1">{i18n.t('admin_panel.step_timer_hint')}</p>
    </div>
  );
};

export default StepTimerInput;
